import React from 'react'

// import { Box, Typography } from '@material-ui/core'

// import InputGroup from '../../../UI/Forms/InputGroup/InputGroup'
// import Modal from '../../../UI/Modal/Modal'
// import Button from '../../../UI/Button/Button'
import FormModal from '../../../FormModal/FormModal'

const ForgetPassModal = ({ open, onHide, forgetForm, onFormChange, onFormSubmit }) => {
  return (
    <FormModal
      open={open}
      onCancel={onHide}
      onSubmit={onFormSubmit}
      form={forgetForm}
      onChange={onFormChange}
      size={'sm'}
      header={'forgetPassword'}
      showCloseButton={true}
    />

    // <Modal
    // open={open}
    // onHide={onHide}
    // footer={
    //   <Button color={'primary'} clicked={onFormSubmit} disabled={!forgetForm.valid}>
    //     {translate('getPassword')}
    //   </Button>
    // }
    // header={translate('forgetPassword')}
    // backdropClicked={onHide}>
    // <Box
    //   title={
    //     <Typography variant={'title'} gutterBottom>
    //       {translate('getPasswordInEmail')}
    //     </Typography>
    //   }>
    //   <InputGroup
    //     key={'forget'}
    //     label={translate(forgetForm.label)}
    //     inputType={forgetForm.elementType}
    //     configs={forgetForm.elementConfig}
    //     invalid={!forgetForm.valid}
    //     validations={forgetForm.validation}
    //     touched={forgetForm.touched}
    //     changed={e => onFormChange(e)}
    //     value={forgetForm.value}
    //     validationError={forgetForm.error}
    //   />
    // </Box>
    // </Modal>
  )
}

export default ForgetPassModal
